module.exports = __webpack_public_path__ + "img/ico-profile.187aaede.svg";